import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTweetEyeIconProps extends SvgIconProps {}
/**
 * component used to display tweet eye icon in twitter interaction
 * @param props - CcfTweetEyeIconProps
 * @example - <CcfTweetEyeIcon />
 * @returns SVG of  tweet eye icon in twitter interaction
 */
export function CcfTweetEyeIcon(props: CcfTweetEyeIconProps)  {
  return (
    <SvgIcon {...props}>
      <g id="ic_message_public" clip-path="url(#clip-ic_message_public)">
        <path id="Icon_material-remove-red-eye" data-name="Icon material-remove-red-eye" d="M8.833,6.75a7.885,7.885,0,0,0-7.333,5,7.878,7.878,0,0,0,14.667,0A7.885,7.885,0,0,0,8.833,6.75Zm0,8.333a3.333,3.333,0,1,1,3.333-3.333A3.335,3.335,0,0,1,8.833,15.083Zm0-5.333a2,2,0,1,0,2,2A2,2,0,0,0,8.833,9.75Z" transform="translate(-0.833 -3.25)" />
      </g>
    </SvgIcon>
  );
}

export default CcfTweetEyeIcon;
